<div class="modal-header pb-0">
  <div class="close" (click)="close()" style="position: relative; top: -8px;">
    <img src="assets/img/common/close-icon.png" alt="">  
  </div>    
</div>

<div class="modal-body">
  <div class="row">
    <button type="button" class="btn btn-block mx-3" data-dismiss="modal" (click) = "goToPlay()" style="background: #ffcb50; color: #00231f;margin: 10px 0px;">{{ 'play_free' | translate}}</button>
    <button type="button" class="btn btn-block mx-3" (click) = "goToWallet()" style="background: #017078; color: #fff;margin: 10px 0px;">{{ 'game_balance_transfer' | translate}}</button>
  </div>     
</div>